<p-treeTable
  styleClass="p-treetable-sm text-md"
  filterMode="lenient"
  #tt
  [tableStyle]="{ 'min-width': '20rem' }"
  [value]="treeIndicators"
  [globalFilterFields]="['name']"
  [paginator]="treeIndicators.length > 15"
  [rows]="15"
  [scrollable]="true">
  <ng-template pTemplate="caption">
    <div class="flex justify-content-end align-items-center w-full">
      <div class="p-input-icon-left w-full">
        <i class="fas fa-search"></i>
        <input
          class="w-full"
          type="text"
          pInputText
          placeholder="durchsuchen ..."
          (input)="
            tt.filterGlobal(getTarget($event.target).value, 'contains')
          " />
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
    <tr [ttRow]="rowNode" (click)="handleRowClick(rowNode.node, $event)">
      <td
        [ngClass]="{
          'pl-2': rowData.type === 'default',
          'pl-5': rowData.type === 'child',
          'py-1 px-0': rowData.type === 'set',
        }">
        <div class="flex align-items-center gap-2 cursor-pointer">
          @if (rowData.type !== 'set') {
            <i class="mr-2 fas fa-ruler-vertical"></i>
          } @else {
            <p-treeTableToggler [rowNode]="rowNode"> </p-treeTableToggler>
          }

          {{ rowData?.name }}
          @if (widgetStore.isIndicatorInSelection(rowData.key)) {
            <i class="ml-auto fas fa-check-circle"></i>
          }
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="togglericon" let-open>
    @if (open) {
      <i class="fas fa-ruler"></i>
    } @else {
      <i class="fas fa-ruler-combined"></i>
    }
  </ng-template>
</p-treeTable>
